import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Route } from 'react-router'

export default function MainMenuBreadcrumb({ history }) {
    return (history.location.pathname.includes('training') ?
            <React.Fragment>
                <Breadcrumb className='secondary admin-bc'>
                <BreadcrumbItem active={history.location.pathname === '/home'} className='secondary' onClick={() => { history.push('/home') }}>Trainings</BreadcrumbItem>
                <Route path='/trainings/training' render={routeProps => <BreadcrumbItem {...getBreadcrumbRules(routeProps)} >Training</BreadcrumbItem>} />
                </Breadcrumb>
            </React.Fragment> :
            <React.Fragment>
            <Breadcrumb className='secondary admin-bc'>
                <Route path='/programs' render={routeProps => <BreadcrumbItem {...getBreadcrumbRules(routeProps)} >Projects</BreadcrumbItem>} />
                <Route path='/programs/program' render={routeProps => <BreadcrumbItem {...getBreadcrumbRules(routeProps)} >Project</BreadcrumbItem>} />
            </Breadcrumb>
          </React.Fragment>
    );
}

const getBreadcrumbRules = (routeProps) => {
    return {
        active: routeProps.match.url === routeProps.location.pathname,
        className: 'secondary',
        onClick: () => {
            routeProps.history.push(routeProps.match.url)
        }
    };
};


